import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

// import { Notification } from '../models/notification.model';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from './translate.service';

@Injectable()
export class NotificationService {
    // private _notifications = new Subject<Notification>();
    // public noteAdded = this._notifications.asObservable();
    private viewContainerRef: any;

    constructor(
        private notificationsService: NotificationsService,
        private translateService: TranslateService
    ) { }

    public success(message: string, title?: string) {
        // this._notifications.next(new Notification('success', message, title));
        this.notificationsService.success(title || 'Success', this.getTranslation(message));
    }

    public error(message: string, title?: string) {
        // this._notifications.next(new Notification('error', message, title));
        this.notificationsService.error(title || 'Failed', this.getTranslation(message));
    }

    public alert(message: string, title?: string) {
        // this._notifications.next(new Notification('alert', message, title));
        this.notificationsService.alert(title || 'Alert', this.getTranslation(message));
    }

    public info(message: string, title?: string) {
        // this._notifications.next(new Notification('info', message, title));
        this.notificationsService.info(title || 'Info', this.getTranslation(message));
    }

    public setViewContainerRef(viewContainerRef: any) {
        this.viewContainerRef = viewContainerRef;
    }

    private getTranslation(key: string): string{
        return this.translateService.translate(key);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/notification.service.ts